// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/notesEditor/trash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvatarBlock{
    position: relative;
    display: flex;
    width: 100%;
    padding: 5px 5px;
    margin-bottom: 5px;
    gap: 10px;
}

.avatarEditor_overlay{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.avatarEditor_overlay_empty{
    border: 2px solid #ccc0;
    margin: 0px;
    font-size: 0;
    pointer-events: none;
}

.avatarEditor_overlay_drag{
    border: 2px dashed #ccc;
}

.avatarEditor_overlay_drop{
    border: 2px dashed #009537;
}

.AvatarBlock_avatar{
    width: 96px;
    height: 96px;
    border-radius: 100%;
    flex-shrink: 0;
    background-color: #ccc;
    overflow: hidden;
    position: relative;
    text-shadow: 0 0 3px #fff, 0 0 2px #fff, 0 0 1px #fff;
}

.avatarEditor_fileInput{
    display: none;
}

.avatarEditor_fileLabel{
    position: relative;
    display: flex;
    cursor: pointer;
    width: 100%;
    height: 100%;

    justify-content: center;
    text-align: center;
    align-items: center;
    font-weight: 700;
    font-size: 11px;
    padding: 5px;
}

.AvatarBlock_editButton{
    width: 32px;
    height: 32px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 18px;
    background-position: center;
    background-repeat: no-repeat;
    font-size: 0;
    cursor: pointer;
}

.AvatarBlock_editButton--remove{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.5;
}

.AvatarBlock_previewCanvas{
    width: 100%;
    height: 100%;
    position: absolute;
}

.AvatarBlock_previewCanvas--hide{
    opacity: 0;
}

.AvatarBlock_wrapper{
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/addClient/AvatarBlock.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;;IAEZ,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yDAAiE;IACjE,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf","sourcesContent":[".AvatarBlock{\n    position: relative;\n    display: flex;\n    width: 100%;\n    padding: 5px 5px;\n    margin-bottom: 5px;\n    gap: 10px;\n}\n\n.avatarEditor_overlay{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    border-radius: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.avatarEditor_overlay_empty{\n    border: 2px solid #ccc0;\n    margin: 0px;\n    font-size: 0;\n    pointer-events: none;\n}\n\n.avatarEditor_overlay_drag{\n    border: 2px dashed #ccc;\n}\n\n.avatarEditor_overlay_drop{\n    border: 2px dashed #009537;\n}\n\n.AvatarBlock_avatar{\n    width: 96px;\n    height: 96px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-color: #ccc;\n    overflow: hidden;\n    position: relative;\n    text-shadow: 0 0 3px #fff, 0 0 2px #fff, 0 0 1px #fff;\n}\n\n.avatarEditor_fileInput{\n    display: none;\n}\n\n.avatarEditor_fileLabel{\n    position: relative;\n    display: flex;\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    font-weight: 700;\n    font-size: 11px;\n    padding: 5px;\n}\n\n.AvatarBlock_editButton{\n    width: 32px;\n    height: 32px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../../../assets/edit.svg');\n    background-size: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n    font-size: 0;\n    cursor: pointer;\n}\n\n.AvatarBlock_editButton--remove{\n    background-image: url('../../../../assets/notesEditor/trash.svg');\n    opacity: 0.5;\n}\n\n.AvatarBlock_previewCanvas{\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\n.AvatarBlock_previewCanvas--hide{\n    opacity: 0;\n}\n\n.AvatarBlock_wrapper{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
